import React from 'react';
import { Badge } from 'react-bootstrap';
import { statusFull } from '../helpers/projReportHelper';

export default function ReportStatusBadge({ status, width }) {
  const foundStatus = statusFull[status];

  if (foundStatus) return <Badge style={{ width }} pill bg={foundStatus.bg}>{foundStatus.label}</Badge>;

  return <Badge pill bg="secondary" />;
}
